module.exports = __webpack_public_path__ + "img/delete-patient.f8a0ed17.png";